import { Accordion } from '@delmonicos/shared-design-system-react/src/components/accordion/accordion';
import { NumberFixed } from '@delmonicos/shared-design-system-react/src/components/number-fixed/number-fixed';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  StatisticsAreaGranularityEnum,
  StatisticsTimeGranularityEnum,
} from '@model/enum/statistics-granularity.enum';
import { useCpmsBoGetTransactionReportsCountQuery } from '@service/cpms-bo-transaction-reports-count-statistics.service';

import { useFilters } from '../context/filters.context';
import * as css from '../statistics.module.scss';
import { MoreLessTransactionsChargePointCardComponent } from './cards/more-less-transactions-charge-point.card';
import { TransactionsByConnectorTypeCard } from './cards/transactions-by-connector-type.card';
import { TransactionsByMonthCard } from './cards/transactions-by-date.card';
import { TransactionsByDayCard } from './cards/transactions-by-day.card';
import { TransactionsByLocationCard } from './cards/transactions-by-location.card';
import { TransactionsByThirdPartyEndpointCard } from './cards/transactions-by-third-party-endpoint.card';
import { TransactionsDurationsCard } from './cards/transactions-durations.card';

export const TransactionsSectionComponent = (): React.JSX.Element => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const {
    transformedFilters,
    filters: { areaGranularity, timeGranularity },
  } = useFilters();

  const { data: countTransactions } = useCpmsBoGetTransactionReportsCountQuery({
    ...transformedFilters,
  });

  const renderTitle = () => (
    <div className={css.accordionTitle}>
      <AccentTitle
        as={HeadingEnum.H2}
        icon="electric-car-2"
        text={t('$.statistics.transactions.title')}
      />
      <div className={classNames(css.transaction, css.count)}>
        <NumberFixed
          bold
          fontSize={TextFontSize.Inherit}
          number={countTransactions?.total ?? 0}
          digits={0}
        />
        <Text fontSize={TextFontSize.Medium}>
          {t('$.statistics.transactions.unit')}
        </Text>
      </div>
    </div>
  );

  return (
    <Accordion
      title={renderTitle()}
      isOpen={isOpen}
      onToggle={() => setIsOpen(true)}>
      <Stack gap={GapEnum.L} direction="column">
        <Stack direction="row" gap={GapEnum.XL}>
          <TransactionsDurationsCard />
          <MoreLessTransactionsChargePointCardComponent />
        </Stack>
        <Stack gap={GapEnum.XL}>
          {areaGranularity !== StatisticsAreaGranularityEnum.Location &&
            areaGranularity !== StatisticsAreaGranularityEnum.ChargePoint && (
              <TransactionsByLocationCard />
            )}
          {timeGranularity === StatisticsTimeGranularityEnum.Month ? (
            <TransactionsByDayCard />
          ) : (
            <TransactionsByMonthCard />
          )}
        </Stack>
        <Stack gap={GapEnum.XL}>
          <TransactionsByThirdPartyEndpointCard />
          <TransactionsByConnectorTypeCard />
        </Stack>
      </Stack>
    </Accordion>
  );
};
